import { useEffect } from "react";
import { IAlimento, INecessidadesDia } from "../../../../Interfaces/eficiencia_alimentar/planoAlimentar_GrupoHomo";
import { StyledTableCell, StyledTableHead } from "../../../../Styles/tabelCellStyled/customTableCell";
import { CustomTextField } from "../../../../Styles/theme/customThemeprovider";
import { format_strings_to_numbers } from "../../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { func_print } from "../../../../Func_genericas/func_print";
import { desformatarNumero, formatarNumero_recebido_com_casa_decimais } from "../../../../Func_genericas/formatar_numero_formato_pt";


interface ICampoFosforoUmProps {
    tabela: INecessidadesDia | undefined;
    setTabela: React.Dispatch<React.SetStateAction<INecessidadesDia | undefined>>;
    set_flag_editado: React.Dispatch<React.SetStateAction<boolean>>;
    lista_keys_para_erros: any;
    titulo: any;
    index: number
    fosforo_total_outra_tabela: number
    gordura_outra_tabela: number
    proteina_outra_tabela: number
}

export const FosforoCampoUm: React.FC<ICampoFosforoUmProps> = ({
    tabela,
    setTabela,
    lista_keys_para_erros,
    titulo,
    index,
    fosforo_total_outra_tabela,
    gordura_outra_tabela,
    proteina_outra_tabela,
    set_flag_editado
}) => {

    const message_apenas_numero = ("Apenas números são aceites");



    const calculos_primeira_metade_fosforo = (pastagem: number, pastagem_ptotal: number, silagem: number, silagem_ptotal: number, outras_ferragens: number, outras_ptotal: number, alimento_composto: number, fosforo_total_outra_tabela: number) => {
        try {
            let p_pastagem = 0;
            let f_pastagem_ptotal = 0;
            let q_silagem = 0;
            let i_silagem_ptotal = 0;
            let r_outras_ferragens = 0;
            let l_outras_ptotal = 0;
            let s_alimento_composto = 0;
            let j_fosforo_total_outra_tabela = 0;

            if (Number.isNaN(pastagem)) {
                p_pastagem = 0
            } else {
                p_pastagem = pastagem
            }
            if (Number.isNaN(pastagem_ptotal)) {
                f_pastagem_ptotal = 0
            } else {
                f_pastagem_ptotal = pastagem_ptotal
            }
            if (Number.isNaN(silagem)) {
                q_silagem = 0
            } else {
                q_silagem = silagem
            }
            if (Number.isNaN(silagem_ptotal)) {
                i_silagem_ptotal = 0
            } else {
                i_silagem_ptotal = silagem_ptotal
            }
            if (Number.isNaN(outras_ferragens)) {
                r_outras_ferragens = 0
            } else {
                r_outras_ferragens = outras_ferragens
            }
            if (Number.isNaN(outras_ptotal)) {
                l_outras_ptotal = 0
            } else {
                l_outras_ptotal = outras_ptotal
            }
            if (Number.isNaN(alimento_composto)) {
                s_alimento_composto = 0
            } else {
                s_alimento_composto = alimento_composto
            }
            if (Number.isNaN(fosforo_total_outra_tabela)) {
                j_fosforo_total_outra_tabela = 0
            } else {
                j_fosforo_total_outra_tabela = fosforo_total_outra_tabela
            }
            let aux = ((p_pastagem * f_pastagem_ptotal) + (q_silagem * i_silagem_ptotal) + (r_outras_ferragens * l_outras_ptotal) + (s_alimento_composto * j_fosforo_total_outra_tabela))
            let aux1 = (p_pastagem + q_silagem + r_outras_ferragens + s_alimento_composto) * 1000
            let aux2 = aux / aux1 * 100
            return Number.isNaN(aux2) ? 0 : aux2
        } catch (error) {
            func_print('error calculos_primeira_metade: ', error)
            return 0
        }
    }
    const calculos_primeira_metade_proteina = (pastagem: number, pastagem_PB: number, silagem: number, silagem_PB: number, outras_ferragens: number, outras_PB: number, alimento_composto: number, proteina_outra_tabela: number) => {
        try {
            let p_pastagem = 0;
            let g_pastagem_PB = 0;
            let q_silagem = 0;
            let j_silagem_PB = 0;
            let r_outras_ferragens = 0;
            let m_outras_PB = 0;
            let s_alimento_composto = 0;
            let b_gordura_outra_tabela = 0;

            if (Number.isNaN(pastagem)) {
                p_pastagem = 0
            } else {
                p_pastagem = pastagem
            }
            if (Number.isNaN(pastagem_PB)) {
                g_pastagem_PB = 0
            } else {
                g_pastagem_PB = pastagem_PB
            }
            if (Number.isNaN(silagem)) {
                q_silagem = 0
            } else {
                q_silagem = silagem
            }
            if (Number.isNaN(silagem_PB)) {
                j_silagem_PB = 0
            } else {
                j_silagem_PB = silagem_PB
            }
            if (Number.isNaN(outras_ferragens)) {
                r_outras_ferragens = 0
            } else {
                r_outras_ferragens = outras_ferragens
            }
            if (Number.isNaN(outras_PB)) {
                m_outras_PB = 0
            } else {
                m_outras_PB = outras_PB
            }
            if (Number.isNaN(alimento_composto)) {
                s_alimento_composto = 0
            } else {
                s_alimento_composto = alimento_composto
            }
            if (Number.isNaN(proteina_outra_tabela)) {
                b_gordura_outra_tabela = 0
            } else {
                b_gordura_outra_tabela = proteina_outra_tabela
            }
            let aux = ((p_pastagem * g_pastagem_PB) + (q_silagem * j_silagem_PB) + (r_outras_ferragens * m_outras_PB) + (s_alimento_composto * b_gordura_outra_tabela))
            let aux1 = (p_pastagem + q_silagem + r_outras_ferragens + s_alimento_composto) * 1000
            let aux2 = aux / aux1 * 100
            return Number.isNaN(aux2) ? 0 : aux2
        } catch (error) {
            func_print('error calculos_primeira_metade_proteina: ', error)
            return 0
        }
    }
    const calculos_primeira_metade_gordura = (pastagem: number, pastagem_GB: number, silagem: number, silagem_GB: number, outras_ferragens: number, outras_GB: number, alimento_composto: number, gordura_outra_tabela: number) => {
        try {
            let p_pastagem = 0;
            let h_pastagem_GB = 0;
            let q_silagem = 0;
            let k_silagem_GB = 0;
            let r_outras_ferragens = 0;
            let n_outras_GB = 0;
            let s_alimento_composto = 0;
            let c_gordura_outra_tabela = 0;

            if (Number.isNaN(pastagem)) {
                p_pastagem = 0
            } else {
                p_pastagem = pastagem
            }
            if (Number.isNaN(pastagem_GB)) {
                h_pastagem_GB = 0
            } else {
                h_pastagem_GB = pastagem_GB
            }
            if (Number.isNaN(silagem)) {
                q_silagem = 0
            } else {
                q_silagem = silagem
            }
            if (Number.isNaN(silagem_GB)) {
                k_silagem_GB = 0
            } else {
                k_silagem_GB = silagem_GB
            }
            if (Number.isNaN(outras_ferragens)) {
                r_outras_ferragens = 0
            } else {
                r_outras_ferragens = outras_ferragens
            }
            if (Number.isNaN(outras_GB)) {
                n_outras_GB = 0
            } else {
                n_outras_GB = outras_GB
            }
            if (Number.isNaN(alimento_composto)) {
                s_alimento_composto = 0
            } else {
                s_alimento_composto = alimento_composto
            }
            if (Number.isNaN(gordura_outra_tabela)) {
                c_gordura_outra_tabela = 0
            } else {
                c_gordura_outra_tabela = gordura_outra_tabela
            }
            let aux = ((h_pastagem_GB * p_pastagem) + (k_silagem_GB * q_silagem) + (n_outras_GB * r_outras_ferragens) + (s_alimento_composto * c_gordura_outra_tabela))
            let aux1 = (p_pastagem + q_silagem + r_outras_ferragens + s_alimento_composto) * 1000
            let aux2 = aux / aux1 * 100
            return Number.isNaN(aux2) ? 0 : aux2
        } catch (error) {
            func_print('error calculos_primeira_metade_proteina: ', error)
            return 0
        }
    }
    useEffect(() => {

    }, []);


    const onInputChange = (event: any) => {
        const { name, value } = event.target;
        set_flag_editado(true)

        let pastagem_index = "camp_" + index + "_pastagem" as keyof INecessidadesDia
        let pastagem = tabela === undefined ? 0 : tabela[pastagem_index] === undefined ? 0 : tabela[pastagem_index]
        let pastagem_ptotal_index = "camp_" + index + "_pastagem_ptotal" as keyof INecessidadesDia
        let pastagem_ptotal = tabela === undefined ? 0 : tabela[pastagem_ptotal_index] === undefined ? 0 : tabela[pastagem_ptotal_index]
        let silagem_index = "camp_" + index + "_silagem" as keyof INecessidadesDia
        let silagem = tabela === undefined ? 0 : tabela[silagem_index] === undefined ? 0 : tabela[silagem_index]
        let silagem_ptotal_index = "camp_" + index + "_silagem_ptotal" as keyof INecessidadesDia
        let silagem_ptotal = tabela === undefined ? 0 : tabela[silagem_ptotal_index] === undefined ? 0 : tabela[silagem_ptotal_index]
        let outras_ferragens_index = "camp_" + index + "_outras_ferragens" as keyof INecessidadesDia
        let outras_ferragens = tabela === undefined ? 0 : tabela[outras_ferragens_index] === undefined ? 0 : tabela[outras_ferragens_index]
        let outras_ptotal_index = "camp_" + index + "_outras_ptotal" as keyof INecessidadesDia
        let outras_ptotal = tabela === undefined ? 0 : tabela[outras_ptotal_index] === undefined ? 0 : tabela[outras_ptotal_index]
        let alimento_composto_index = "camp_" + index + "_alimento_composto" as keyof INecessidadesDia
        let alimento_composto = tabela === undefined ? 0 : tabela[alimento_composto_index] === undefined ? 0 : tabela[alimento_composto_index]
        let pastagem_PB_index = "camp_" + index + "_pastagem_PB" as keyof INecessidadesDia
        let pastagem_PB = tabela === undefined ? 0 : tabela[pastagem_PB_index] === undefined ? 0 : tabela[pastagem_PB_index]
        let outras_PB_index = "camp_" + index + "_outras_PB" as keyof INecessidadesDia
        let outras_PB = tabela === undefined ? 0 : tabela[outras_PB_index] === undefined ? 0 : tabela[outras_PB_index]
        let silagem_PB_index = "camp_" + index + "_silagem_PB" as keyof INecessidadesDia
        let silagem_PB = tabela === undefined ? 0 : tabela[silagem_PB_index] === undefined ? 0 : tabela[silagem_PB_index]
        let pastagem_GB_index = "camp_" + index + "_pastagem_GB" as keyof INecessidadesDia
        let pastagem_GB = tabela === undefined ? 0 : tabela[pastagem_GB_index] === undefined ? 0 : tabela[pastagem_GB_index]
        let outras_GB_index = "camp_" + index + "_outras_GB" as keyof INecessidadesDia
        let outras_GB = tabela === undefined ? 0 : tabela[outras_GB_index] === undefined ? 0 : tabela[outras_GB_index]
        let silagem_GB_index = "camp_" + index + "_silagem_GB" as keyof INecessidadesDia
        let silagem_GB = tabela === undefined ? 0 : tabela[silagem_GB_index] === undefined ? 0 : tabela[silagem_GB_index]

        if (name === "camp_" + index + "_materia_seca") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.materia_seca = true
            } else {
                lista_keys_para_erros.materia_seca = false
                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                }));
            }
        } else if (name === "camp_" + index + "_UFV") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.UFV = true
            } else {
                lista_keys_para_erros.UFV = false
                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                }));
            }
        } else if (name === "camp_" + index + "_proteina_bruta") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.proteina_bruta = true
            } else {
                lista_keys_para_erros.proteina_bruta = false
                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                }));
            }
        } else if (name === "camp_" + index + "_NDF") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.NDF = true
            } else {
                lista_keys_para_erros.NDF = false
                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                }));
            }
        } else if (name === "camp_" + index + "_pastagem_ptotal") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.pastagem_ptotal = true
            } else {
                lista_keys_para_erros.pastagem_ptotal = false
                let aux_value1 = format_strings_to_numbers(value)
                let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0


                let fosforo = calculos_primeira_metade_fosforo(
                    Number(pastagem),
                    aux_value,
                    Number(silagem),
                    Number(silagem_ptotal),
                    Number(outras_ferragens),
                    Number(outras_ptotal),
                    Number(alimento_composto),
                    Number(fosforo_total_outra_tabela)
                );

                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                    ['camp_' + index + '_fosforo']: fosforo
                }));
            }
        } else if (name === "camp_" + index + "_pastagem_PB") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.pastagem_PB = true
            } else {
                lista_keys_para_erros.pastagem_PB = false
                let aux_value2 = format_strings_to_numbers(value)
                let aux_value3 = typeof (aux_value2) === 'number' ? aux_value2 : 0
                let proteina = calculos_primeira_metade_proteina(
                    Number(pastagem),
                    aux_value3,
                    Number(silagem),
                    Number(silagem_PB),
                    Number(outras_ferragens),
                    Number(outras_PB),
                    Number(alimento_composto),
                    Number(proteina_outra_tabela)
                );

                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                    ['camp_' + index + '_proteina']: proteina,
                }));

            }
        } else if (name === "camp_" + index + "_pastagem_GB") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.pastagem_GB = true
            } else {
                lista_keys_para_erros.pastagem_GB = false
                let aux_value4 = format_strings_to_numbers(value)
                let aux_value5 = typeof (aux_value4) === 'number' ? aux_value4 : 0
                let gordura = calculos_primeira_metade_gordura(
                    Number(pastagem),
                    aux_value5,
                    Number(silagem),
                    Number(silagem_GB),
                    Number(outras_ferragens),
                    Number(outras_GB),
                    Number(alimento_composto),
                    Number(gordura_outra_tabela)
                );
                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                    ['camp_' + index + '_gordura']: gordura,
                }));
            }
        } else if (name === "camp_" + index + "_silagem_ptotal") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.silagem_ptotal = true
            } else {
                lista_keys_para_erros.silagem_ptotal = false
                let aux_value1 = format_strings_to_numbers(value)
                let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                let fosforo = calculos_primeira_metade_fosforo(
                    Number(pastagem),
                    Number(pastagem_ptotal),
                    Number(silagem),
                    aux_value,
                    Number(outras_ferragens),
                    Number(outras_ptotal),
                    Number(alimento_composto),
                    Number(fosforo_total_outra_tabela)
                );
                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                    ['camp_' + index + '_fosforo']: fosforo
                }));
            }
        } else if (name === "camp_" + index + "_silagem_PB") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.silagem_PB = true
            } else {
                lista_keys_para_erros.silagem_PB = false
                let aux_value2 = format_strings_to_numbers(value)
                let aux_value3 = typeof (aux_value2) === 'number' ? aux_value2 : 0
                let proteina = calculos_primeira_metade_proteina(
                    Number(pastagem),
                    Number(pastagem_PB),
                    Number(silagem),
                    aux_value3,
                    Number(outras_ferragens),
                    Number(outras_PB),
                    Number(alimento_composto),
                    Number(proteina_outra_tabela)
                );

                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                    ['camp_' + index + '_proteina']: proteina,

                }));
            }
        } else if (name === "camp_" + index + "_silagem_GB") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.silagem_GB = true
            } else {
                lista_keys_para_erros.silagem_GB = false
                let aux_value4 = format_strings_to_numbers(value)
                let aux_value5 = typeof (aux_value4) === 'number' ? aux_value4 : 0
                let gordura = calculos_primeira_metade_gordura(
                    Number(pastagem),
                    Number(pastagem_GB),
                    Number(silagem),
                    aux_value5,
                    Number(outras_ferragens),
                    Number(outras_GB),
                    Number(alimento_composto),
                    Number(gordura_outra_tabela)
                );

                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                    ['camp_' + index + '_gordura']: gordura,
                }));
            }
        } else if (name === "camp_" + index + "_outras_ptotal") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.outras_ptotal = true
            } else {
                lista_keys_para_erros.outras_ptotal = false
                let aux_value1 = format_strings_to_numbers(value)
                let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                let fosforo = calculos_primeira_metade_fosforo(
                    Number(pastagem),
                    Number(pastagem_ptotal),
                    Number(silagem),
                    Number(silagem_ptotal),
                    Number(outras_ferragens),
                    aux_value,
                    Number(alimento_composto),
                    Number(fosforo_total_outra_tabela)
                );
                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                    ['camp_' + index + '_fosforo']: fosforo
                }));
            }
        } else if (name === "camp_" + index + "_outras_PB") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.outras_PB = true
            } else {
                lista_keys_para_erros.outras_PB = false
                let aux_value2 = format_strings_to_numbers(value)
                let aux_value3 = typeof (aux_value2) === 'number' ? aux_value2 : 0
                let proteina = calculos_primeira_metade_proteina(
                    Number(pastagem),
                    Number(pastagem_PB),
                    Number(silagem),
                    Number(silagem_PB),
                    Number(outras_ferragens),
                    aux_value3,
                    Number(alimento_composto),
                    Number(proteina_outra_tabela)
                );

                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                    ['camp_' + index + '_proteina']: proteina,
                }));
            }
        } else if (name === "camp_" + index + "_outras_GB") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.outras_GB = true
            } else {
                lista_keys_para_erros.outras_GB = false
                let aux_value4 = format_strings_to_numbers(value)
                let aux_value5 = typeof (aux_value4) === 'number' ? aux_value4 : 0
                let gordura = calculos_primeira_metade_gordura(
                    Number(pastagem),
                    Number(pastagem_GB),
                    Number(silagem),
                    Number(silagem_GB),
                    Number(outras_ferragens),
                    aux_value5,
                    Number(alimento_composto),
                    Number(gordura_outra_tabela)
                );

                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                    ['camp_' + index + '_gordura']: gordura,
                }));
            }
        } else if (name === "camp_" + index + "_leite") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.leite = true
            } else {
                lista_keys_para_erros.leite = false
                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                }));
            }
        } else if (name === "camp_" + index + "_pastagem") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.pastagem = true
            } else {
                lista_keys_para_erros.pastagem = false
                let aux_value1 = format_strings_to_numbers(value)
                let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0


                let fosforo = calculos_primeira_metade_fosforo(
                    aux_value,
                    Number(pastagem_ptotal),
                    Number(silagem),
                    Number(silagem_ptotal),
                    Number(outras_ferragens),
                    Number(outras_ptotal),
                    Number(alimento_composto),
                    Number(fosforo_total_outra_tabela)
                );

                let aux_value2 = format_strings_to_numbers(value)
                let aux_value3 = typeof (aux_value2) === 'number' ? aux_value2 : 0
                let proteina = calculos_primeira_metade_proteina(
                    aux_value3,
                    Number(pastagem_PB),
                    Number(silagem),
                    Number(silagem_PB),
                    Number(outras_ferragens),
                    Number(outras_PB),
                    Number(alimento_composto),
                    Number(proteina_outra_tabela)
                );

                let aux_value4 = format_strings_to_numbers(value)
                let aux_value5 = typeof (aux_value4) === 'number' ? aux_value4 : 0
                let gordura = calculos_primeira_metade_gordura(
                    aux_value5,
                    Number(pastagem_GB),
                    Number(silagem),
                    Number(silagem_GB),
                    Number(outras_ferragens),
                    Number(outras_GB),
                    Number(alimento_composto),
                    Number(gordura_outra_tabela)
                );
                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                    ['camp_' + index + '_fosforo']: fosforo,
                    ['camp_' + index + '_proteina']: proteina,
                    ['camp_' + index + '_gordura']: gordura,
                }));

            }
        } else if (name === "camp_" + index + "_silagem") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.silagem = true
            } else {
                lista_keys_para_erros.silagem = false
                let aux_value1 = format_strings_to_numbers(value)
                let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                let fosforo = calculos_primeira_metade_fosforo(
                    Number(pastagem),
                    Number(pastagem_ptotal),
                    aux_value,
                    Number(silagem_ptotal),
                    Number(outras_ferragens),
                    Number(outras_ptotal),
                    Number(alimento_composto),
                    Number(fosforo_total_outra_tabela)
                );
                let aux_value2 = format_strings_to_numbers(value)
                let aux_value3 = typeof (aux_value2) === 'number' ? aux_value2 : 0
                let proteina = calculos_primeira_metade_proteina(
                    Number(pastagem),
                    Number(pastagem_PB),
                    aux_value3,
                    Number(silagem_PB),
                    Number(outras_ferragens),
                    Number(outras_PB),
                    Number(alimento_composto),
                    Number(proteina_outra_tabela)
                );
                let aux_value4 = format_strings_to_numbers(value)
                let aux_value5 = typeof (aux_value4) === 'number' ? aux_value4 : 0
                let gordura = calculos_primeira_metade_gordura(
                    Number(pastagem),
                    Number(pastagem_GB),
                    aux_value5,
                    Number(silagem_GB),
                    Number(outras_ferragens),
                    Number(outras_GB),
                    Number(alimento_composto),
                    Number(gordura_outra_tabela)
                );

                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                    ['camp_' + index + '_proteina']: proteina,
                    ['camp_' + index + '_fosforo']: fosforo,
                    ['camp_' + index + '_gordura']: gordura,
                }));


            }
        } else if (name === "camp_" + index + "_outras_ferragens") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.outras_ferragens = true
            } else {
                lista_keys_para_erros.outras_ferragens = false
                let aux_value1 = format_strings_to_numbers(value)
                let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                let fosforo = calculos_primeira_metade_fosforo(
                    Number(pastagem),
                    Number(pastagem_ptotal),
                    Number(silagem),
                    Number(silagem_ptotal),
                    aux_value,
                    Number(outras_ptotal),
                    Number(alimento_composto),
                    Number(fosforo_total_outra_tabela)
                );
                let aux_value2 = format_strings_to_numbers(value)
                let aux_value3 = typeof (aux_value2) === 'number' ? aux_value2 : 0
                let proteina = calculos_primeira_metade_proteina(
                    Number(pastagem),
                    Number(pastagem_PB),
                    Number(silagem),
                    Number(silagem_PB),
                    aux_value3,
                    Number(outras_PB),
                    Number(alimento_composto),
                    Number(proteina_outra_tabela)
                );
                let aux_value4 = format_strings_to_numbers(value)
                let aux_value5 = typeof (aux_value4) === 'number' ? aux_value4 : 0
                let gordura = calculos_primeira_metade_gordura(
                    Number(pastagem),
                    Number(pastagem_GB),
                    Number(silagem),
                    Number(silagem_GB),
                    aux_value5,
                    Number(outras_GB),
                    Number(alimento_composto),
                    Number(gordura_outra_tabela)
                );

                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                    ['camp_' + index + '_proteina']: proteina,
                    ['camp_' + index + '_fosforo']: fosforo,
                    ['camp_' + index + '_gordura']: gordura,
                }));

            }
        } else if (name === "camp_" + index + "_alimento_composto") {
            if (/[a-zA-Z]/.test(value)) {
                lista_keys_para_erros.alimento_composto = true
            } else {
                lista_keys_para_erros.alimento_composto = false
                let aux_value1 = format_strings_to_numbers(value)
                let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                let fosforo = calculos_primeira_metade_fosforo(
                    Number(pastagem),
                    Number(pastagem_ptotal),
                    Number(silagem),
                    Number(silagem_ptotal),
                    Number(outras_ferragens),
                    Number(outras_ptotal),
                    aux_value,
                    Number(fosforo_total_outra_tabela)
                );
                let aux_value2 = format_strings_to_numbers(value)
                let aux_value3 = typeof (aux_value2) === 'number' ? aux_value2 : 0
                let proteina = calculos_primeira_metade_proteina(
                    Number(pastagem),
                    Number(pastagem_PB),
                    Number(silagem),
                    Number(silagem_PB),
                    Number(outras_ferragens),
                    Number(outras_PB),
                    aux_value3,
                    Number(proteina_outra_tabela)
                );
                let aux_value4 = format_strings_to_numbers(value)
                let aux_value5 = typeof (aux_value4) === 'number' ? aux_value4 : 0
                let gordura = calculos_primeira_metade_gordura(
                    Number(pastagem),
                    Number(pastagem_GB),
                    Number(silagem),
                    Number(silagem_GB),
                    Number(outras_ferragens),
                    Number(outras_GB),
                    aux_value5,
                    Number(gordura_outra_tabela)
                );

                setTabela((prevAzoto: any) => ({
                    ...prevAzoto,
                    [name]: format_strings_to_numbers(value, false),
                    ['camp_' + index + '_proteina']: proteina,
                    ['camp_' + index + '_fosforo']: fosforo,
                    ['camp_' + index + '_gordura']: gordura,
                }));

            }
        } else {

            setTabela((prevAzoto: any) => ({
                ...prevAzoto,
                [name]: value,
            }));
        }

    }



    return (
        <>
            <StyledTableHead>
                {titulo}
            </StyledTableHead>
            <StyledTableCell>
                <CustomTextField
                    value={tabela?.[('camp_' + index + '_materia_seca') as keyof INecessidadesDia] === null || tabela?.[('camp_' + index + '_materia_seca') as keyof INecessidadesDia] === undefined ? '' : (tabela?.[('camp_' + index + '_materia_seca') as keyof INecessidadesDia]).toString().replace('.', ',')}
                    name={'camp_' + index + '_materia_seca'}
                    onChange={onInputChange}
                    error={lista_keys_para_erros.materia_seca}
                    helperText={lista_keys_para_erros.materia_seca ? message_apenas_numero : ""} />
            </StyledTableCell>
            <StyledTableCell>
                <CustomTextField
                    value={tabela?.[('camp_' + index + '_UFV') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_UFV') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_UFV') as keyof INecessidadesDia]).toString().replace('.', ',')}
                    name={"camp_" + index + "_UFV"}
                    onChange={onInputChange}
                    error={lista_keys_para_erros.UFV}
                    helperText={lista_keys_para_erros.UFV ? message_apenas_numero : ""} />
            </StyledTableCell>
            <StyledTableCell>
                <CustomTextField
                    value={tabela?.[('camp_' + index + '_proteina_bruta') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_proteina_bruta') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_proteina_bruta') as keyof INecessidadesDia]).toString().replace('.', ',')}
                    name={"camp_" + index + "_proteina_bruta"}
                    onChange={onInputChange}
                    error={lista_keys_para_erros.proteina_bruta}
                    helperText={lista_keys_para_erros.proteina_bruta ? message_apenas_numero : ""} />
            </StyledTableCell>
            <StyledTableCell>
                <CustomTextField
                    name={"camp_" + index + "_NDF"}
                    value={tabela?.[('camp_' + index + '_NDF') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_NDF') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_NDF') as keyof INecessidadesDia]).toString().replace('.', ',')}
                    onChange={onInputChange}
                    error={lista_keys_para_erros.NDF}
                    helperText={lista_keys_para_erros.NDF ? message_apenas_numero : ""} />
            </StyledTableCell>
            <StyledTableCell sx={{ backgroundColor: index > 4 ? "lightgray" : '' }}>
                {
                    index > 4 ? <></> :
                        <CustomTextField
                            name={"camp_" + index + "_pastagem_ptotal"}
                            value={tabela?.[('camp_' + index + '_pastagem_ptotal') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_pastagem_ptotal') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_pastagem_ptotal') as keyof INecessidadesDia]).toString().replace('.', ',')}
                            onChange={onInputChange}
                            error={lista_keys_para_erros.pastagem_ptotal}
                            helperText={lista_keys_para_erros.pastagem_ptotal ? message_apenas_numero : ""} />
                }

            </StyledTableCell>
            <StyledTableCell>
                <CustomTextField
                    name={"camp_" + index + "_pastagem_PB"}
                    value={tabela?.[('camp_' + index + '_pastagem_PB') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_pastagem_PB') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_pastagem_PB') as keyof INecessidadesDia]).toString().replace('.', ',')}
                    onChange={onInputChange}
                    error={lista_keys_para_erros._pastagem_PB}
                    helperText={lista_keys_para_erros.pastagem_PB ? message_apenas_numero : ""} />
            </StyledTableCell>
            <StyledTableCell>
                <CustomTextField
                    name={"camp_" + index + "_pastagem_GB"}
                    value={tabela?.[('camp_' + index + '_pastagem_GB') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_pastagem_GB') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_pastagem_GB') as keyof INecessidadesDia]).toString().replace('.', ',')}
                    onChange={onInputChange}
                    error={lista_keys_para_erros._pastagem_GB}
                    helperText={lista_keys_para_erros._pastagem_GB ? message_apenas_numero : ""} />
            </StyledTableCell>
            <StyledTableCell>
                <CustomTextField
                    name={"camp_" + index + "_silagem_ptotal"}
                    value={tabela?.[('camp_' + index + '_silagem_ptotal') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_silagem_ptotal') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_silagem_ptotal') as keyof INecessidadesDia]).toString().replace('.', ',')}
                    onChange={onInputChange}
                    error={lista_keys_para_erros.silagem_ptotal}
                    helperText={lista_keys_para_erros.silagem_ptotal ? message_apenas_numero : ""} />
            </StyledTableCell>
            <StyledTableCell>
                <CustomTextField
                    name={"camp_" + index + "_silagem_PB"}
                    value={tabela?.[('camp_' + index + '_silagem_PB') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_silagem_PB') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_silagem_PB') as keyof INecessidadesDia]).toString().replace('.', ',')}
                    onChange={onInputChange}
                    error={lista_keys_para_erros.silagem_PB}
                    helperText={lista_keys_para_erros.silagem_PB ? message_apenas_numero : ""} />
            </StyledTableCell>
            <StyledTableCell>
                <CustomTextField
                    name={"camp_" + index + "_silagem_GB"}
                    value={tabela?.[('camp_' + index + '_silagem_GB') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_silagem_GB') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_silagem_GB') as keyof INecessidadesDia]).toString().replace('.', ',')}
                    onChange={onInputChange}
                    error={lista_keys_para_erros.silagem_GB}
                    helperText={lista_keys_para_erros.silagem_GB ? message_apenas_numero : ""} />
            </StyledTableCell>
            <StyledTableCell>
                <CustomTextField
                    name={"camp_" + index + "_outras_ptotal"}
                    value={tabela?.[('camp_' + index + '_outras_ptotal') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_outras_ptotal') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_outras_ptotal') as keyof INecessidadesDia]).toString().replace('.', ',')}
                    onChange={onInputChange}
                    error={lista_keys_para_erros.outras_ptotal}
                    helperText={lista_keys_para_erros.outras_ptotal ? message_apenas_numero : ""} />
            </StyledTableCell>
            <StyledTableCell>
                <CustomTextField
                    name={"camp_" + index + "_outras_PB"}
                    value={tabela?.[('camp_' + index + '_outras_PB') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_outras_PB') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_outras_PB') as keyof INecessidadesDia]).toString().replace('.', ',')}
                    onChange={onInputChange}
                    error={lista_keys_para_erros.outras_PB}
                    helperText={lista_keys_para_erros.outras_PB ? message_apenas_numero : ""} />
            </StyledTableCell>
            <StyledTableCell>
                <CustomTextField
                    name={"camp_" + index + "_outras_GB"}
                    value={tabela?.[('camp_' + index + '_outras_GB') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_outras_GB') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_outras_GB') as keyof INecessidadesDia]).toString().replace('.', ',')}
                    onChange={onInputChange}
                    error={lista_keys_para_erros.outras_GB}
                    helperText={lista_keys_para_erros.outras_GB ? message_apenas_numero : ""} />
            </StyledTableCell>
            <StyledTableCell sx={{ backgroundColor: index > 4 ? "lightgray" : '' }}>
                {
                    index > 4 ? <></> :
                        <CustomTextField
                            name={"camp_" + index + "_leite"}
                            value={tabela?.[('camp_' + index + '_leite') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_leite') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_leite') as keyof INecessidadesDia]).toString().replace('.', ',')}
                            onChange={onInputChange}
                            error={lista_keys_para_erros.leite}
                            helperText={lista_keys_para_erros.leite ? message_apenas_numero : ""} />
                }
            </StyledTableCell>
            <StyledTableCell>
                <CustomTextField
                    name={"camp_" + index + "_pastagem"}
                    value={tabela?.[('camp_' + index + '_pastagem') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_pastagem') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_pastagem') as keyof INecessidadesDia]).toString().replace('.', ',')}
                    onChange={onInputChange}
                    error={lista_keys_para_erros.pastagem}
                    helperText={lista_keys_para_erros.pastagem ? message_apenas_numero : ""} />
            </StyledTableCell>
            <StyledTableCell>
                <CustomTextField
                    name={"camp_" + index + "_silagem"}
                    value={tabela?.[('camp_' + index + '_silagem') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_silagem') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_silagem') as keyof INecessidadesDia]).toString().replace('.', ',')}
                    onChange={onInputChange}
                    error={lista_keys_para_erros.silagem}
                    helperText={lista_keys_para_erros.silagem ? message_apenas_numero : ""} />
            </StyledTableCell>
            <StyledTableCell>
                <CustomTextField
                    name={"camp_" + index + "_outras_ferragens"}
                    value={tabela?.[('camp_' + index + '_outras_ferragens') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_outras_ferragens') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_outras_ferragens') as keyof INecessidadesDia]).toString().replace('.', ',')}
                    onChange={onInputChange}
                    error={lista_keys_para_erros.outras_ferragens}
                    helperText={lista_keys_para_erros.outras_ferragens ? message_apenas_numero : ""} />
            </StyledTableCell>
            <StyledTableCell>
                <CustomTextField
                    name={"camp_" + index + "_alimento_composto"}

                    value={tabela?.[('camp_' + index + '_alimento_composto') as keyof INecessidadesDia] === undefined || tabela?.[('camp_' + index + '_alimento_composto') as keyof INecessidadesDia] === null ? '' : (tabela?.[('camp_' + index + '_alimento_composto') as keyof INecessidadesDia]).toString().replace('.', ',')}
                    onChange={onInputChange}
                    error={lista_keys_para_erros.alimento_composto}
                    helperText={lista_keys_para_erros.alimento_composto ? message_apenas_numero : ""} />
            </StyledTableCell>
            <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>

                {tabela?.[('camp_' + index + '_fosforo') as keyof INecessidadesDia] === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(Number(tabela?.[('camp_' + index + '_fosforo') as keyof INecessidadesDia]))}

            </StyledTableCell>
            <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>
                {tabela?.[('camp_' + index + '_proteina') as keyof INecessidadesDia] === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(Number(tabela?.[('camp_' + index + '_proteina') as keyof INecessidadesDia]))}
            </StyledTableCell>
            <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>
                {tabela?.[('camp_' + index + '_gordura') as keyof INecessidadesDia] === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(Number(tabela?.[('camp_' + index + '_gordura') as keyof INecessidadesDia]))}
            </StyledTableCell>
        </>
    )
}